import { useQuery } from '@tanstack/react-query';
import type { CommerceInfoDTO } from '@meshsmith/shared';
import { api } from '../lib/api';
import { rupees } from '../lib/format';

/** What the store has set up that the whole storefront talks about: where it ships from, and when shipping is free. */
export function useCommerce() {
  const { data } = useQuery({
    queryKey: ['commerce'],
    queryFn: () => api.get<CommerceInfoDTO>('/content/commerce'),
    staleTime: 5 * 60_000,
    retry: false,
  });
  return {
    info: data,
    /** "₹1,499", or null while loading or when shipping is never free */
    freeShippingOver: data?.freeShippingOver ? rupees(data.freeShippingOver.amount, data.freeShippingOver.currency) : null,
    /** what paying online saves ("₹50") and from what order value, or null when the store has no such offer */
    onlineOffer: data?.onlineOffer ? { amount: data.onlineOffer.amount, minSubtotal: data.onlineOffer.minSubtotal, text: rupees(data.onlineOffer.amount, data.onlineOffer.currency) } : null,
  };
}
